import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SegovSigepoSpinnerStdComponent } from './controls/segov-sigepo-spinner.std/segov-sigepo-spinner.std.component';
import { Title } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { Settings } from 'luxon';

import localePt from '@angular/common/locales/pt';
import {registerLocaleData} from '@angular/common';
import { GoogleAnalyticsService } from './services/analytics/google-analytics.service';
import { CookieBannerComponent } from "./controls/cookie-banner/cookie-banner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SegovSigepoSpinnerStdComponent, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  constructor(
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly titleService: Title
  ) {
    this.titleService.setTitle(environment.systemName);
    Settings.defaultLocale = 'pt-BR'
    registerLocaleData(localePt)
  }

  ngOnInit(): void {
    this.googleAnalyticsService.trackPageView();
    Settings.defaultWeekSettings = { firstDay: 7, minimalDays: 1, weekend: [6, 7] };
    localStorage.clear();
  }
}
